import { render, staticRenderFns } from "./RobotAccounts.vue?vue&type=template&id=2a213dc6&scoped=true"
import script from "./RobotAccounts.vue?vue&type=script&lang=js"
export * from "./RobotAccounts.vue?vue&type=script&lang=js"
import style0 from "./RobotAccounts.vue?vue&type=style&index=0&id=2a213dc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a213dc6",
  null
  
)

export default component.exports